import React from "react";
import styles from "./OfferType.module.sass";

const offerType = props => {
  const className = props.inline ? styles.InlineLabel : styles.OfferLabel;
  return (
    <>
      <div
        className={[
          styles.OfferType,
          props.className,
          props.large ? " " + styles.large : ""
        ].join(" ")}
      >
        {props.showIcon && !props.inline ? (
          <i className={styles.Icon + " icon icon-consorcio"} />
        ) : null}
        <h2 className={className}>
          <span>Consórcio </span>
          {parseInt(props.type) === 2 ? "de Veículos" : "Imobiliário"}
        </h2>
      </div>
      <div className={styles.GroupContainer}>
        <h3 className={styles.GroupLabel}>{props.groupLabel}</h3>
        <p className={styles.GroupNumber}>{props.groupNumber}</p>
      </div>
    </>
  );
};

export default offerType;
